import { Alert, Descriptions, Space, Tag, Typography } from 'antd';
import type { NocCoreMessageConfirmation, NocSimCommandResult, NocSimInjectResult } from '@goelectric/shared-types';

/** Resultado de un comando downlink con la confirmación del core. */
export function CommandResultView({ result }: { result: NocSimCommandResult }) {
  const succeeded = result.confirmations.length > 0 && result.confirmations.every((item) => item.success);
  return (
    <Alert
      type={succeeded ? 'success' : 'warning'}
      showIcon
      message={`${result.command} enviado a ${result.stationId} (${result.protocol})`}
      description={
        <Space direction="vertical" size={6} style={{ width: '100%' }}>
          <Descriptions size="small" column={1}>
            <Descriptions.Item label="Core">
              <Tag color="blue">
                OCPP {result.core.version} · {result.core.module}/{result.core.action}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="requestId">
              <Typography.Text code>{result.requestId}</Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="correlationId">
              {result.correlationId ? (
                <Typography.Text code>{result.correlationId}</Typography.Text>
              ) : (
                <Typography.Text type="secondary">n/a (el core no lo informó)</Typography.Text>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Confirmaciones">
              {result.confirmations.length === 0
                ? '—'
                : result.confirmations.map((confirmation, index) => (
                    <Tag key={index} color={confirmation.success ? 'green' : 'red'}>
                      {confirmation.success ? 'success' : 'fallo'}
                    </Tag>
                  ))}
            </Descriptions.Item>
          </Descriptions>
          <ConfirmationPayloads confirmations={result.confirmations} />
        </Space>
      }
    />
  );
}

function ConfirmationPayloads({ confirmations }: { confirmations: NocCoreMessageConfirmation[] }) {
  const withPayload = confirmations.filter((item) => item.payload !== undefined && item.payload !== null);
  if (withPayload.length === 0) {
    return null;
  }
  return (
    <Typography.Paragraph style={{ marginBottom: 0 }}>
      <pre className="lab-json">{JSON.stringify(withPayload, null, 2)}</pre>
    </Typography.Paragraph>
  );
}

/** Resultado de una inyección uplink (respuesta cruda del VCP). */
export function InjectResultView({ result }: { result: NocSimInjectResult }) {
  return (
    <Alert
      type="success"
      showIcon
      message={`${result.action} inyectado en ${result.stationId}`}
      description={<span>Respuesta del VCP: <code>{result.response || 'OK'}</code></span>}
    />
  );
}
